import React, { useState } from "react";
import Modal from "../../../../components/modal";
import Button from "../../../../components/new-button";
import styles from "../delete-brand-modal/styles.module.scss";
import toast from "react-hot-toast";
import useEquipmentStore, {
  fetchBrands,
  fetchModels,
} from "../../../../stores/equipment";
import { deleteEquipments } from "../../../../../api";

const DeleteEquipmentModal = ({ open, onClose, brandId }) => {
  const [submitting, setSubmitting] = useState(false);
  const activeModel = useEquipmentStore((state) => state.activeModel);

  const remove = async () => {
    setSubmitting(true);

    try {
      toast.loading("Deleting equipment...");

      const response = await deleteEquipments({ id: activeModel.id });
      toast.dismiss();

      if (!response?.status) {
        toast.error(
          response?.message || "There was a problem deleting the equipment",
        );
        console.error(response);
        onClose();
        return;
      }

      toast.success("Equipment deleted successfully");
      if (brandId) {
        fetchModels(brandId);
      } else {
        fetchBrands();
      }
      onClose();
    } catch (error) {
      toast.error("There was a problem deleting the equipment");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      header="Are you sure want to remove this equipment? You cannot undo this action."
      headingCenteredSpaced
      isOpen={open}
      onClose={onClose}
    >
      <div className={styles.actionWrapper}>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={remove} disabled={submitting}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteEquipmentModal;
